import React, { Component } from "react";
import { NavLink } from "react-router-dom";

class Breadcump extends Component {
  render() {
    return (
      <div>
        <div id="breadcump" style={{ background: "#111a28" }}>
          <div className="space"></div>
          <div className="container">
            <div className="col-12 text-center">
              <NavLink
                style={{
                  color: "#00cf5d",
                  fontSize: "30px",
                  fontWeight: "500",
                }}
                className="mx-3"
                exact
                to="/"
              >
                হোম
              </NavLink>
              <span
                style={{
                  color: "#ffffff",
                  fontSize: "30px",
                  fontWeight: "500",
                }}
                className="text-white"
              >
                {" "}
                /{" "}
              </span>
              <span
                style={{
                  color: "#ffffff",
                  fontSize: "30px",
                  fontWeight: "500",
                }}
                className="mx-3"
              >
                {this.props.pageText}
              </span>
            </div>
          </div>
          <div className="space"></div>
        </div>
      </div>
    );
  }
}

export default Breadcump;
